import { styled, alpha } from "@mui/material";
const AnimationDot = styled("div")(
  ({ size, topOffset, rightOffset, color, theme }) => {
    var _a, _b, _c, _d, _e, _f;
    return {
      ":after": {
        animation: `shadow-pulse__RutlBg 4s infinite`,
        backgroundColor: (_b = (_a = theme.vars.palette) == null ? void 0 : _a[color]) == null ? void 0 : _b.main,
        borderRadius: "50%",
        content: '""',
        display: "block",
        height: `${size}px`,
        width: `${size}px`,
        position: "absolute",
        right: `${rightOffset}px`,
        top: `${topOffset}px`,
        "@keyframes  shadow-pulse__RutlBg": {
          "0%": { boxShadow: `0 0 0 0 ${alpha((_d = (_c = theme.palette) == null ? void 0 : _c[color]) == null ? void 0 : _d.main, 0.5)}` },
          "50%": { boxShadow: `0 0 0 0 ${(_f = (_e = theme.vars.palette) == null ? void 0 : _e[color]) == null ? void 0 : _f.main}` },
          "100%": { boxShadow: `0 0 0 ${size}px transparent` }
        }
      }
    };
  }
);
export {
  AnimationDot
};
//# sourceMappingURL=AnimationDot.js.map
